import DateFormat from '@/Enums/Format/DateFormat.enum';
import type { ICampaignExportData, ICampaignExportLineItemRow } from '@/helpers/campaignManagement/campaignExport';
import { type CsvColumn, downloadRowsAsCsv } from '@/helpers/csv';
import { slugifyForFilename } from '@/helpers/file';
import moment from 'moment';

const columns: CsvColumn<ICampaignExportLineItemRow>[] = [
  { header: 'Campaign Name', value: row => row.campaignName },
  { header: 'Campaign ID', value: row => row.campaignId },
  { header: 'Campaign Start (UTC)', value: row => row.campaignStart },
  { header: 'Campaign End (UTC)', value: row => row.campaignEnd },
  { header: 'Line Item Name', value: row => row.lineItemName },
  { header: 'Line Item ID', value: row => row.lineItemId },
  { header: 'Line Item Start (UTC)', value: row => row.lineItemStart },
  { header: 'Line Item End (UTC)', value: row => row.lineItemEnd },
  { header: 'Impressions Booked', value: row => row.impressionsBooked },
  { header: 'Bid CPM', value: row => row.bidCpm },
  // Renamed per #4446. This is a CSV header, so anything parsing the export
  // by column NAME will need updating; column order is unchanged.
  { header: 'Client CPM', value: row => row.soldCpm },
  { header: 'Channel', value: row => row.channel },
  { header: 'Devices', value: row => row.devices },
  { header: 'Product', value: row => row.product },
  { header: 'Pacing', value: row => row.pacing },
  { header: 'Daily Impression Cap', value: row => row.dailyImpressionCap },
  { header: 'Publishers', value: row => row.publishers },
  { header: 'Geo Selection', value: row => row.geo },
  { header: 'Audiences', value: row => row.audiences },
  { header: 'Dayparting', value: row => row.daypart },
  { header: 'Creative Names', value: row => row.creativeNames },
  { header: 'Creative Dates', value: row => row.creativeDates },
  { header: 'Creative Weights', value: row => row.creativeWeights },
];

export const getCampaignExportColumns = (includeBidCpm: boolean): CsvColumn<ICampaignExportLineItemRow>[] =>
  includeBidCpm ? columns : columns.filter(({ header }) => header !== 'Bid CPM');

export const getCampaignExportFileName = (campaignName: string): string =>
  `${slugifyForFilename(campaignName) || 'campaign'}-export-${moment.utc().format(DateFormat.Iso8601)}`;

export const downloadCampaignExport = (data: ICampaignExportData): void =>
  downloadRowsAsCsv(
    data.lineItemRows,
    getCampaignExportColumns(data.includeBidCpm),
    getCampaignExportFileName(data.campaignName),
    // Publisher and creative names carry accents and dashes Excel would otherwise mangle.
    { withBom: true },
  );
